import { AiAutomationStats } from 'shared/api/requests/aiAutomation/schemas'

export enum LoaderStatus {
  NOT_LOADED = 'NOT_LOADED',
  LOADED = 'LOADED',
  LOADING = 'LOADING',
}

export interface AiAutomationStatsState {
  stats: AiAutomationStats
  loaderStatus: LoaderStatus
}
